import React from "react";
import styled from "styled-components";
import "./style.css";
import { CustomLabel } from "../../Constant";
import DropdownCardContent from "./DropDownInput";

const DropDownCardStyle = styled.div`
  background-color: #f2f2f2;
  width: 400px;
  position: absolute;
  top: 60px;
  z-index: 999;
  visibility: ${(props) => (props.open ? "visible !important" : "hidden")};
  opacity: ${(props) => (props.open ? "1 !important" : "0")};
  transition: 0.1s;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.2);
  &:hover {
    box-shadow: 0 0 32.2px 2.8px rgba(244, 126, 31, 0.2);
  }
  @media (max-width: 767px) {
    width: 310px;
  }
`;

const UparrowDiv = styled.div`
  width: 0;
  height: 0;
  border-width: 0 15px 20px 15px;
  border-color: transparent transparent #f2f2f2 transparent;
  border-style: solid;
  position: absolute;
  z-index: 1001;
  top: -20px;
`;

const DropdownCardComponent = ({ data,dropDownopen, onCancel, onDataChange,onOk }) => {
  return (
    <DropDownCardStyle open={dropDownopen}>
      <UparrowDiv></UparrowDiv>
      <div className="BoxCloseCross" onClick={onCancel}>
        <CustomLabel font_size="16" >
          &nbsp;X&nbsp;
        </CustomLabel>
      </div>
      {data.adultData.length > 0 &&
        data.adultData.map((ei, i) => (
          <React.Fragment key={`${ei?.dob}-${i}`}>
            <DropdownCardContent lable={"Adult"} num={i + 1} p_data={ei} onDataChange={onDataChange} user_data_info = {data}/>
          </React.Fragment>
        ))}
      {data.childData.length > 0 &&
        data.childData.map((ei, i) => (
          <React.Fragment key={`${ei.dob}-${i}`}>
            <DropdownCardContent lable={"Child"} num={i + 1} p_data={ei} onDataChange={onDataChange} user_data_info = {data}/>
          </React.Fragment>
        ))}
        <div className="my-3 center">
        <button className="btn-primary-btn" type="button" onClick={onOk}>Ok</button>
        </div>
    </DropDownCardStyle>
  );
};

export default DropdownCardComponent;
